import React, { useEffect, useRef, useState } from 'react';
import styles from './service.module.css';
import {
    Loading,
    ServiceBanner,
    ServiceSlides
} from '../../components';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import useServiceAnimations from '../../hooks/useServiceAnimations';
import { useDispatch, useSelector } from "react-redux";
import { fetchWhatWeDoData } from '../../slice/whatWeDoSlice';
import { ServiceCard } from '../../../constants';
import ServiceSlideOne from '../../components/service-sections/ServiceSlideOne';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const Service = () => {
    const [isContentLoaded, setIsContentLoaded] = useState(false);
    const [colors, setColors] = useState([]);
    const servicesRef = useRef(null);

    const colorPalette = ['#000000', '#DD043E', '#3e5beb', '#CE1974', '#6652C4'];

    // Function to get the next color without repeating the last one

  /*   useEffect(() => {
        // Generate colors once when the component mounts
        const generatedColors = serviceData.map((_, index) => colorPalette[index % colorPalette.length]);
        setColors(generatedColors);

        const images = servicesRef.current.querySelectorAll('img');
        let loadedImages = 0;

        const imageLoaded = () => {
            loadedImages++;
            if (loadedImages === images.length) {
                setIsContentLoaded(true);
            }
        };

        images.forEach(img => {
            if (img.complete) {
                imageLoaded();
            } else {
                img.addEventListener('load', imageLoaded);
                img.addEventListener('error', imageLoaded); // In case an image fails to load
            }
        });

        return () => {
            images.forEach(img => {
                img.removeEventListener('load', imageLoaded);
                img.removeEventListener('error', imageLoaded);
            });
        };
    }, []);
 */
    useServiceAnimations(isContentLoaded);

      const dispatch = useDispatch();
        const { data: serviceData, loading, error } = useSelector((state) => state.whatWeDo);
    
        useEffect(() => {
            dispatch(fetchWhatWeDoData());
        }, [dispatch]);

            // Log the data whenever it changes
            useEffect(() => {
                if (serviceData.length > 0) {
                    setTimeout(()=> {
                        setIsContentLoaded(true)
                    }, 250);
                    
                    const generatedColors = serviceData.map((_, index) => colorPalette[index % colorPalette.length]);
        setColors(generatedColors);
                }
                
              }, [serviceData]);


    return (
        <>
             {loading && <Loading />} 

             {!loading && (
            <div
                className={`${styles.serviceSec}  ${!loading ? styles.loaded : ''
                    }`}
                ref={servicesRef}
                style={{ visibility: !loading ? 'visible' : 'hidden' }}
            >
                <ServiceBanner/>
                
               
               {/* {serviceData.length >0  && serviceData.map((slide, index) => (
                    <ServiceSlideOne key={slide._id} slide={slide} index = {index}/>
                ))}   */}
                
               
                {/* {serviceData.map((slide) => (
                    <ServiceSlide1 slide={slide} />
                ))} */}
                {/* <ServiceSlide1/>
                <ServiceSlide2/>
                <ServiceSlide3/>
                <ServiceSlide4/>
                <ServiceSlide5/>
                <ServiceSlide6/>
                <ServiceSlide7/>
                <ServiceSlide8/> */}
                {serviceData.length > 0 && serviceData.map((service, index) => (
                    <ServiceSlides
                        key={service._id}
                        id={service.title}
                        extraClass={`slide_${service._id}`}
                        count={index + 1}
                        title={service.title}
                        titleAr = {service.titleAr}
                        bgColor={colors[index]}
                        //disc={service.description}
                        description={service.description}
                        descriptionAr={service.descriptionAr}
                        badges={service.features.map(badge => badge)}
                        img={service.image}
                        link={`/what-we-do/${service._id}`} 
                    />
                ))}
            </div>
            )}
        </>
    );
};

export default Service;
